import React, { useEffect, useState } from 'react'
import './header.css'
import { Link } from 'react-router-dom'
import { getPublicURL } from '../../shared/utility'
import { I_Logo } from '../../shared/interfaces'
import Profile from '../../components/header-profile/header-profile'
import Buttons from '../../components/buttons/buttons'
import InputSearch from '../../utils/controls/input-search'
import HeaderProfile from '../../components/header-profile/header-profile'
import Logo from '../../images/Logo.svg'

export default function Header() {
    return (
        <div className="header p-lg-relative">
            <div className="container d-flex align-items-center justify-content-between h-100">
                <h5 className='darktext font-18 segoeui-semibold mt-2 m-0 d-flex align-items-center' tabIndex={0} aria-label='Financial Assistant'><span className='icon-ai-assistant title-color16 pe-2 font-22'></span>Financial Assistant</h5>
                <div className='d-flex align-items-center h-100'>
                    <HeaderProfile />
                </div>
            </div>
        </div>
    )
}
